import React, { useEffect } from "react";
import { _goToAllTodayReminders } from "routers/helper";
import { useIsFocused } from "@react-navigation/native";

import { View } from "react-native";
import { Text, Icon, Empty, Button, Loading, ReminderBox } from "components";
import { getFormatedDate } from "react-native-modern-datepicker";

import { colors, sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import css from "styles";
import { mq, sn } from "utils";

import { useHome } from "clients/apis";
import tinycolor from "tinycolor2";

export default function TodayRemindersSection() {
  const isFocused = useIsFocused();

  const auth = useRecoilValue(authAtom);

  const { data, refetch, isLoading } = useHome();

  useEffect(() => {
    isFocused && refetch();
  }, [isFocused, refetch]);

  const _renderContent = () => {
    if (isLoading) {
      return (
        <>
          <View style={{ height: 10 }} />
          <Loading />
        </>
      );
    }

    if (data?.data?.reminders?.length === 0) {
      return (
        <View style={{ alignItems: "center", marginTop: 2 * sizes.space }}>
          <Icon type="oct" name="bell-slash" />
          <Text weight="extraBold" color={colors.text.muted}>
            یادآوری برای امروز ندارید
          </Text>
        </View>
      );
    }

    return (
      <View style={{ ...css.wrap, ...css.rRowCenterAlignSpaceBetween }}>
        {data?.data?.reminders?.map((reminder: ReminderT, key: number) => (
          <View key={String(key)} style={css.responsiveBoxContainer}>
            <ReminderBox
              dateMode="time"
              reminder={reminder}
              refreshList={refetch}
              actions={["archives", "delete"]}
            />
          </View>
        ))}
      </View>
    );
  };

  return (
    <>
      <View style={{ paddingBottom: 80 }}>
        <View
          style={{
            ...css.rRowCenterAlign,
            paddingTop: 10,
            marginBottom: sizes.space,
            borderTopWidth: 2,
            borderColor: colors.white,
          }}
        >
          <Icon
            color={tinycolor(auth?.company?.color).lighten(15).toString()}
            name="bell"
          />
          <Text weight="extraBold" size="lg">
            {" "}
            {strings.today_reminders}
          </Text>
          <View style={{ marginRight: sizes.space, top: sn(1, 1, 2, 2) }}>
            <Text
              top={1}
              size={"lg"}
              weight="extraBold"
              color={tinycolor(auth?.company?.color).darken(15).toString()}
            >
              {getFormatedDate(new Date(), "jYYYY/jMM/jDD")}
            </Text>
          </View>
        </View>
        {_renderContent()}
      </View>
    </>
  );
}
